import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { confirmEmail } from '../api/auth';

export function ConfirmEmailPage() {
  const [params] = useSearchParams();
  const userId = params.get('userId') ?? '';
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'loading' | 'ok' | 'fail'>('loading');

  useEffect(() => {
    if (!userId || !token) { setState('fail'); return; }
    confirmEmail(userId, token).then(() => setState('ok')).catch(() => setState('fail'));
  }, [userId, token]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm text-center">
        {state === 'loading' && (
          <p className="text-slate-500 dark:text-slate-400">Confirming your email…</p>
        )}
        {state === 'ok' && (
          <>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-50">Email confirmed</h1>
            <p className="text-slate-500 dark:text-slate-400 mt-2 text-sm">You can now sign in.</p>
            <p className="mt-4">
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/login">
                Go to sign in
              </Link>
            </p>
          </>
        )}
        {state === 'fail' && (
          <>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-50">Link invalid or expired</h1>
            <p className="text-slate-500 dark:text-slate-400 mt-2 text-sm">
              Try requesting a new confirmation email.
            </p>
            <p className="mt-4">
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/resend-confirmation">
                Resend confirmation
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
